import { ButtonGroup } from "@mui/material";
import React from "react";

import { SearchBar, SearchBarProps } from "./SearchBar";

// Styling MUI textField(searchBar)
// https://github.com/mui/material-ui/issues/13570#issuecomment-1127952241
const styles = {
  searchBar: {
    "& fieldset": {
      borderBottomLeftRadius: 0,
      borderTopLeftRadius: 0,
      borderBottomRightRadius: 8,
      borderTopRightRadius: 8,
    },
  },
};

export function FilterSearchToolbar(props: SearchBarProps) {
  const { requestSearch, text, updateSearchText } = props;

  return (
    <div className="p-4 items-stretch border-b-2">
      <ButtonGroup fullWidth variant="outlined" aria-label="buttons">
        <SearchBar
          fullWidth
          // tested className as prop in search bar, we may want add for further styling.
          // className="rounded-l-none rounded-r-8"
          sx={styles.searchBar}
          text={text}
          updateSearchText={updateSearchText}
          requestSearch={requestSearch}
        />
      </ButtonGroup>
    </div>
  );
}
